/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/
const Numeral = require('numeral');

const funcs = {

    getRandomInteger: (min, max) => {
        return Math.floor(
            Math.random() * (max - min + 1) + min
        )        
    },

    sumOfNumbers: (arrayOfNumbers, format) => {
        const sum = arrayOfNumbers.reduce((a, b) => a + b, 0)
        return format ? funcs.standardFormat(sum) : sum
    },

    standardFormat: (num) => {
        return Numeral(num).format('0,0');
    },

    toTwoDecimalPlacesIfNeeded: (num) => {
        Math.round(num*100)/100
    },

    getMinIndexPositionFromArray: (arr) => {
        let minIndex = 0
        for (let i = 1; i < arr.length; i++) {
            if (arr[i] < arr[minIndex]) {
                minIndex = i
            }
        }
        return minIndex
    },

    getMaxIndexPositionFromArray: (arr) => {
        let maxIndex = 0
        for (let i = 1; i < arr.length; i++) {
            if (arr[i] > arr[maxIndex]) {
                maxIndex = i
            }
        }
        return maxIndex
    }
    
}

export default funcs

